<template><div :class="['lu-container',{'lu-container--wide':wide}]"><slot /></div></template>
<script>export default {name:'PublicPageContainer',props:{wide:Boolean}};</script>
